import React, { useState, useEffect } from 'react';
import { MapContainer, TileLayer, GeoJSON } from 'react-leaflet';

const STMMap = () => {
  const [shapes, setShapes] = useState(null);

  useEffect(() => {
    fetch('/shapes.geojson')
      .then(res => res.json())
      .then(data => setShapes(data))
      .catch(err => console.error('Failed to load GeoJSON:', err));
  }, []);

  return (
    <div style={{ width: '100%', height: '400px' }}>
      <MapContainer
        center={[45.5017, -73.5673]}   /* Montreal city center */
        zoom={12}
        style={{ height: '100vh', width: '100%' }}
      >
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution="&copy; OpenStreetMap contributors"
        />
        {shapes && (
          <GeoJSON
            data={shapes}
            style={() => ({
              color: '#0055A4',      /* STM-dark-blue */
              weight: 2,
              opacity: 0.7
            })}
          />
        )}
      </MapContainer>
    </div>

  );
};

export default STMMap;
